<form *ngIf="form" [formGroup]="form" class="mat-typography">
    <table>
        <tr>
            <th>
                Field
            </th>

            <th>
                Current Value
            </th>

            <th>
                Desired Value
            </th>

            <th>
                Status
            </th>
        </tr>



        <tr>
            <td>
                Name
            </td>

            <td>
                {{ policy?.name || 'No Policy'}}
            </td>

            <td>
                {{desiredPolicyValue?.name}}
            </td>

            <td>
                <sway-baseline-status [hasError]="errorsString.includes('name')"></sway-baseline-status>
            </td>
        </tr>

        <tr formGroupName="policy">
            <td>
                Description
            </td>

            <td>
                {{ policy?.description}}
            </td>

            <td>
                <mat-form-field appearance="fill">
                    <textarea matInput formControlName="description"
                        placeholder="Enter a description for the policy"></textarea>
                </mat-form-field>
            </td>

            <td>
                <sway-baseline-status [hasError]="errorsString.includes('description')"></sway-baseline-status>
            </td>
        </tr>

        <tr formGroupName="settings">
            <td>
                <div class="info-wrapper">

                    Enable saving passwords to the password manager

                    <mat-icon [matTooltip]="tooltips.passwordManagerEnabled">info</mat-icon>
                </div>
            </td>

            <td>
                <div class="validator">
                    {{ currentPasswordManagerEnabled || 'Not Set' }}
                </div>
            </td>

            <td>
                <div class="field boolean">
                    <mat-form-field appearance="fill">
                        <mat-select formControlName="passwordManagerEnabled">
                            <mat-option [value]="'enabled'">Enable</mat-option>
                            <mat-option [value]="'disabled'">Disable</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </td>

            <td>
                <sway-baseline-status [hasError]="currentPasswordManagerEnabled?.toLowerCase() !== desiredSettingsValue.passwordManagerEnabled?.toLowerCase()"></sway-baseline-status>
            </td>
        </tr>
    </table>

    <app-intune-policy-assignments [policy]="policy" [errorsString]="errorsString" [assignments]="assignments"
        [form]="form" [tenant_id]="tenant_id"> </app-intune-policy-assignments>
</form>
